export default "__VITE_ASSET__dVjnS6Cp__"